import React, { memo, useEffect, useCallback, Fragment } from "react";
import "./HawkeyeGlobalFilters.scss";
import configStructure from "./configStructure.js";
import Icon from "../Icons/Icon";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import HawkeyeV2FilterPortal from "../HawkeyeV2Filters/HawkeyeV2FilterPortal";
import HawkeyeV2FilterInfo from "../HawkeyeV2FilterInfo/HawkeyeV2FilterInfo";

function HawkeyeGlobalFilters(props) {
  const { setGlobalFilters, globalFilters, selectedGlobalFilter } = props;
  const [state, dispatch] = useAxiomState(
    {
      loading: true,
      isViewingInfo: false,
      searchQuery: "",
    },
    props.appName,
    props.appID,
    "HawkeyeGlobalFilters",
    props.componentID
  );

  // Open filter information modal
  const openShowInfo = useCallback(
    (infoFilter, enableEdit) => {
      document.body.classList.add("no-scroll");
      dispatch({ isViewingInfo: true, infoFilter: infoFilter, enableEdit: enableEdit });
    },
    [dispatch]
  );

  // Close filter information modal
  const closeShowInfo = useCallback(() => {
    document.body.classList.remove("no-scroll");
    dispatch({ isViewingInfo: false, infoFilter: null });
  }, [dispatch]);

  const { searchQuery } = state;

  // Reset search term on options change
  useEffect(() => {
    dispatch((state) => (state.searchQuery ? { searchQuery: "" } : null));
  }, [dispatch, globalFilters]);

  const onSearch = (event) => {
    const value = event.target.value;
    dispatch({ searchQuery: value });
  };

  return (
    <div className="hawkeye-global-filter">
      <div className="hawkeye-global-filter-title">
        <Icon icon="ICON_GLOBAL" className="hawkeye-global-filter-global-icon" />
        <div className="hawkeye-global-filter-title-text">
          {AxiomAPIs.translate("Global Filter")}
        </div>
      </div>
      {
        <div className="hawkeye-global-filter-search">
          <input
            className="hawkeye-global-filter-search-input"
            type="text"
            onChange={onSearch}
            value={searchQuery}
          />
          <div className="hawkeye-global-filter-search-action" type="button">
            <Icon className="hawkeye-global-filter-search-icon" icon="ICON_SEARCH" />
          </div>
        </div>
      }
      <div className="hawkeye-global-filter-container">
        {globalFilters != null &&
          globalFilters.length > 0 &&
          globalFilters.map((filter, index) => {
            let showOption = false;
            const isSelected =
              selectedGlobalFilter != null && selectedGlobalFilter.filterID === filter.filterID
                ? true
                : false;
            if (searchQuery) {
              if (isMatching(filter, searchQuery)) {
                showOption = true;
              }
            } else {
              showOption = true;
            }
            if (showOption) {
              return (
                <div
                  key={"`hawkeye-global-filter-tag_" + index}
                  className={`hawkeye-global-filter-tag ${isSelected ? "is-selected " : ""}`}
                >
                  <button
                    key={index}
                    title={filter.filterName}
                    onClick={() => setGlobalFilters(filter)}
                    data-id={filter.filterName}
                    className={"hawkeye-action hawkeye-global-filter-name"}
                  >
                    {filter.filterName}
                  </button>
                  <button
                    title="Show filter values"
                    onClick={(e) => openShowInfo(filter, false)}
                    className="hawkeye-action hawkeye-global-filter-tag-info"
                  >
                    <Icon icon="ICON_INFO" className="hawkeye-global-filter-tag-icon" />
                  </button>
                </div>
              );
            }
          })}
      </div>
      <HawkeyeV2FilterPortal>
        <Fragment>
          {state.isViewingInfo && (
            <HawkeyeV2FilterInfo
              infoFilter={state.infoFilter}
              closeShowInfo={closeShowInfo}
              enableEdit={state.enableEdit}
            />
          )}
        </Fragment>
      </HawkeyeV2FilterPortal>
    </div>
  );
}

function isMatching(option, searchQuery) {
  return (
    option.filterName != null &&
    String(option.filterName.toUpperCase()).includes(searchQuery.toUpperCase())
  );
}

export default memo(HawkeyeGlobalFilters);
